import { ToolbarDesignTokens } from '@primeuix/themes/types/toolbar';

export const ezToolbarThemeConfig: ToolbarDesignTokens = {
  colorScheme: {
    light: {
      root: {
        borderColor: 'var(--ez-border-color)',
        borderRadius: '12px',
      },
    },
  },
};
